import React, { useState, useContext } from "react";
import { downloadAction } from "../../../../utils/downloadMaster";
import { UserApiContext } from "../../../UserDetailsContext/UserDetailsContext";

export default function DownloadMastersButton({
  masterList = [],
  company_id,
  type,
  totalCount = -1
}) {
  const [isDownloading, setIsDownloading] = useState(false);
  const { userDetails } = useContext(UserApiContext);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      await downloadAction(type, company_id, totalCount, userDetails);
    } catch (error) {
      console.error("Download failed:", error);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <button
      onClick={handleDownload}
      className="btn btn-sm btn-primary ms-2"
      disabled={masterList.length === 0 || isDownloading}
    >
      <i className="fa fa-download mr-2" />{" "}
      {isDownloading ? "Downloading..." : "Download"}
    </button>
  );
}
